module.exports = __webpack_public_path__ + "media/images/version_merge/mobile-0c72bfd57efbe41477d9e17ed39e19bd.svg";